// queries.js

import { gql } from "@apollo/client";

export const GET_TOWERS_QUERY = gql`
  query ($search: String, $first: Int, $skip: Int) {
    towers(search: $search, first: $first, skip: $skip) {
      currentPage
      hasNextPage
      hasPreviousPage
      totalPages
      totalRecords
      items {
        id
        installDate
        numberChannels
        zonkeId
        w3w
        port
        clientSet {
          clientId
          name
          surname
          channel
          expiryDate
          balance
          latestmetertelemetrySet {
            state
          }
          tower {
            id
          }
        }
      }
    }
  }
`;
